import { useEffect } from "react"
import TRACKING from "~/services/tracking"

// Captures `fee_shown` for the rendered price breakdown. Dedupe lives in the
// tracking module (once per view, again on a fee change); unmount ends the view.
export const PayNycFeeShownTracker = (props) => {
  useEffect(() => {
    TRACKING.paynycParking.feeShown(true, props)
  })
  useEffect(() => () => TRACKING.paynycParking.resetFeeShown(), [])
  return null
}

export const TrafficLookupFeeShownTracker = ({ fetcher, ...props }) => {
  useEffect(() => {
    TRACKING.trafficLookup.feeShown(fetcher, props)
  })
  useEffect(() => () => TRACKING.trafficLookup.resetFeeShown(), [])
  return null
}
